import React, { Fragment, PureComponent } from "react"
import styled from "styled-components"
import { FadeIn } from "animate-css-styled-components"
import numeral from "numeral"
import { Info } from "react-feather"
import { injectIntl, FormattedMessage } from "react-intl"
import { Popover } from "antd"
import Box from "../../lib/ui/ui-box"
import Text from "../../components/text"

const QuotesWrapper = styled(Box)`
  box-shadow: 0 6px 9px 0 rgba(144, 164, 183, 0.22);
`

const isQuoteFeatured = ({ featured }) => {
  if (featured) {
    return `
    background: #5c258d;
    background: linear-gradient(
      to right,
      #00B5B8,
      #2C2B59
    ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    transform: scale(1.05);
    `
  } else {
    return `
      background-color: #DDDBDE
    `
  }
}

const QuoteBlock = styled(Box)`
  ${isQuoteFeatured};
`

QuoteBlock.defaultProps = {
  flexDirection: ["column", "column", "row"],
  align: ["fex-end", "flex-start", "flex-end"]
}

const BankLogo = styled.img`
  max-width: 65px;
  filter: ${props => (props.featured ? "grayscale(0%)" : "grayscale(100%)")};
`

const PopoverContentOne = (
  <Box flexDirection="column" w="250px">
    <Text>
      <FormattedMessage id="rates.tooltips.offers.p1" />
    </Text>
  </Box>
)

class RatesQuotes extends PureComponent {
  computeMonthlyPayment = rate => {
    const { propertyValue, cfMortgageType, cfLoanAmount } = this.props
    let balance

    if (cfMortgageType === "renewal") {
      balance = Number(cfLoanAmount)
    } else {
      balance = Number(propertyValue)
    }
    const percentRate = Number(rate) / 100
    const perc1 = 1 + percentRate / 12
    const pow1 = Math.pow(perc1, 12 * 25 + 1)
    const pow2 = pow1 * percentRate / 12

    return numeral(balance * pow2 / (pow1 - 1)).format("($0,0)")
  }

  render() {
    const { products, intl } = this.props
    const [featured, ...restProducts] = products

    return (
      <Fragment>
        <FadeIn duration="0.3s">
          <QuotesWrapper flexDirection="column" bg="white">
            <Box py={[3]} px={[1, 1, 4]} justify="space-between">
              <Text fontSize={[1]} fontWeight="700" color="text">
                <FormattedMessage id="rates.ratesView.best_quote" />
                <Popover
                  content={PopoverContentOne}
                  title="Offers"
                  placement="rightTop"
                >
                  <Info size={20} color="#D8D8D8" />
                </Popover>
              </Text>
              <a
                href={`tel:${intl.formatMessage({
                  id: "nav.numberFormatted"
                })}`}
              >
                <Text
                  onClick={() =>
                    window.analytics.track("Clicked to Call", {
                      location: "rates-quotes",
                      text: "613-769-9213",
                      type: "phone number"
                    })
                  }
                  fontSize={[1]}
                  fontWeight="700"
                  color="text"
                >
                  <FormattedMessage id="nav.number" defaults="613-769-9213" />
                </Text>
              </a>
            </Box>
            <QuoteBlock
              featured
              py={[1, 1, 4]}
              px={[1, 1, 4]}
              w="100%"
              justify="space-between"
            >
              <Box
                flex={0.1}
                my={[1, 0, 0]}
                flexDirection="column"
                align="center"
                justify="center"
              >
                {featured.lender &&
                  featured.lender.logo_path && (
                    <BankLogo
                      featured
                      src={featured.lender.logo_path}
                      alt="Bank Logo"
                    />
                  )}
              </Box>
              <Box
                flex={0.35}
                my={[1]}
                flexDirection="column"
                align="flex-start"
                justify="center"
              >
                <Text
                  fontSize={[3, 3, 3, 4]}
                  lineHeight={[3, 3, 3, 4]}
                  fontWeight="700"
                  color="white"
                >
                  {featured.lender && featured.lender.name}
                </Text>
              </Box>
              <Box flex={0.15} my={[1, 0, 0]} flexDirection="column">
                <Text fontSize={[1]} color="white">
                  <FormattedMessage id="rates.ratesView.rate" />
                </Text>
                <Text
                  fontSize={[3, 3, 3, 4]}
                  lineHeight={[3, 3, 3, 4]}
                  fontWeight="700"
                  color="white"
                >
                  {featured.rate.rate}%
                </Text>
              </Box>
              <Box flex={0.2} my={[1, 0, 0]} flexDirection="column">
                <Text fontSize={[1]} color="white">
                  <FormattedMessage id="rates.ratesView.monthly_payment" />
                </Text>
                <Text
                  fontSize={[3, 3, 3, 4]}
                  lineHeight={[3, 3, 3, 4]}
                  fontWeight="700"
                  color="White"
                >
                  {this.computeMonthlyPayment(featured.rate.rate)}
                </Text>
              </Box>
            </QuoteBlock>
          </QuotesWrapper>

          <QuotesWrapper mt={[5]} flexDirection="column" bg="white">
            <Box py={[3]} px={[1, 1, 4]} justify="space-between">
              <Text fontSize={[1]} fontWeight="700" color="text">
                <FormattedMessage id="rates.ratesView.other_offers" />

                <Popover
                  content={PopoverContentOne}
                  title="Offers"
                  placement="rightTop"
                >
                  <Info size={20} color="#D8D8D8" />
                </Popover>
              </Text>
            </Box>
            {restProducts &&
              restProducts.map(product => {
                return (
                  <QuoteBlock
                    py={[1, 1, 2]}
                    px={[1, 1, 4]}
                    mt={[1]}
                    w="100%"
                    key={product.id}
                    justify="space-between"
                  >
                    <Box
                      flex={0.1}
                      flexDirection="column"
                      align="center"
                      justify="center"
                    >
                      {product.lender &&
                        product.lender.logo_path && (
                          <BankLogo
                            src={product.lender.logo_path}
                            alt="Bank Logo"
                          />
                        )}
                    </Box>
                    <Box
                      flex={0.35}
                      flexDirection="column"
                      align="flex-start"
                      justify="center"
                    >
                      <Text
                        fontSize={[3, 3, 3, 4]}
                        lineHeight={[3, 3, 3, 4]}
                        color="white"
                      >
                        {product.lender && product.lender.name}
                      </Text>
                    </Box>
                    <Box flex={0.15} flexDirection="column">
                      <Text fontSize={[1]} color="white">
                        <FormattedMessage id="rates.ratesView.rate" />
                      </Text>
                      <Text
                        fontSize={[3, 3, 3, 4]}
                        lineHeight={[3, 3, 3, 4]}
                        fontWeight="700"
                        color="white"
                      >
                        {product.rate.rate}%
                      </Text>
                    </Box>
                    <Box flex={0.2} flexDirection="column">
                      <Text fontSize={[1]} color="white">
                        <FormattedMessage id="rates.ratesView.monthly_payment" />
                      </Text>
                      <Text
                        fontSize={[3, 3, 3, 4]}
                        lineHeight={[3, 3, 3, 4]}
                        fontWeight="700"
                        color="White"
                      >
                        {this.computeMonthlyPayment(product.rate.rate)}
                      </Text>
                    </Box>
                  </QuoteBlock>
                )
              })}
          </QuotesWrapper>
        </FadeIn>
      </Fragment>
    )
  }
}

export default injectIntl(RatesQuotes)



// WEBPACK FOOTER //
// ./src/components/rates-quotes/rates-quotes.component.js